<script module lang="ts">
  import type { CollapsibleRootProps } from "#lib/internal/components/collapsible/index"
  import { reactiveContext } from "#lib/internal/helpers"

  export type AccordionItemProps = CollapsibleRootProps & {
    value: string | number
  }

  type ItemContext = {
    readonly value: string | number
  }

  const { getContext, setContext } = reactiveContext<ItemContext>()
  export const getItemContext = getContext
</script>

<script lang="ts">
  import { Collapsible } from "#lib/internal/components/collapsible/index"
  import { cn } from "#lib/utils"
  import type { Snippet } from "svelte"
  import { getRootCtx } from "./AccordionRoot.svelte"

  type Props = AccordionItemProps & {
    children?: Snippet
  }

  let {
    class: className = undefined,
    value,
    children,
    ...restProps
  }: Props = $props()

  const rootCtx = getRootCtx()

  let isOpen = $derived(
    Array.isArray($rootCtx.value)
      ? ($rootCtx.value as (string | number)[]).includes(value)
      : $rootCtx.value === value
  )

  const itemCtx = setContext()
  $effect(() => {
    itemCtx.set({ value })
  })
</script>

<Collapsible.Root
  open={isOpen}
  disabled={$rootCtx.disabled}
  class={cn("border-b", className)}
  {...restProps as any}
>
  {@render children?.()}
</Collapsible.Root>
